/* eslint-disable no-prototype-builtins */

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import { positionChangeWidthSm, mediaGuidelinesString, maximumMediaSize, minimumOnboardingMedia } from '../../../helpers/variableDefaults'
import { standardSpinner } from '../../../helpers/spinners'
import { addImageWithTextButton } from '../../../helpers/buttons'
import { returnSquareImage, returnSquareVideoThumbnail, fileToDataURL } from '../../../helpers/imageHandling'
import { decrementIndex, dummyBox, dummyBoxWidth } from '../../../helpers/globalHelpers'
import { handleImageSelectNewMedia, handleImageSelectNewMediaPrepareForCrop } from '../../../helpers/commonMethods'
import { displayNewMediaJSX } from '../../../helpers/commonJSX'
import { standardErrorContainer } from '../../../helpers/errors'

export const mediaOnboardingJSX = (
  user,
  mediaArray, setMediaArray,
  showCropCarousel, setShowCropCarousel,
  loadingMedia, setLoadingMedia,
  mediaErrors, setMediaErrors,
  width
) => {

  // Adding a new image when the user selects the Upload Image or PhotoCamera button; this is only uploaded to server when User presses Save/Create
  const handleImageSelect = async (e) => {
    await handleImageSelectNewMediaPrepareForCrop(e, mediaArray, setMediaArray, setShowCropCarousel, setLoadingMedia, setMediaErrors, mediaArray.length)
    
  }

  const handleDeleteImage = (e, index) => {
    e.preventDefault(e)
    // console.log('handleDeleteImage pressed')
    // console.log('index ->', index)
    // console.log('mediaArray[index] ->', mediaArray[index])

    // setMediaArray([mediaArray.splice(index, 1)])
    setMediaArray([ ...mediaArray.filter((x, i) => i !== index) ])
  }

  return (
    <>

      {/* Upload Button */}
      {(mediaArray.length < minimumOnboardingMedia || loadingMedia) &&
        <Box sx={{ mt: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          {
            loadingMedia ?
              standardSpinner()
              :
              // button with 'Upload' in white text
              addImageWithTextButton(
                'Upload', 
                `itemImageId`, 
                `imageURL`, 
                'contained',
                'primary',
                mediaArray.length >= 50,
                handleImageSelect,
                '50px',
                '125px'
              )
          }
        </Box>
      }

      {mediaErrors &&
        <Box
          sx={{
            width: '90%',
            maxWidth: '450px',
          }}
        >
          {standardErrorContainer(`A selected file is larger than ${Math.round((maximumMediaSize / 1000000) * .8)}MB. Read the Media Guidelines, check your Internet connection, and try again.`)}
        </Box>
      }


      {/* Advisory Text */}
      {(mediaArray.length < minimumOnboardingMedia || loadingMedia) &&
        <Typography 
          component='pre'
          textAlign={'left'}
          sx={{
            mt: 1,
            width: '85%', maxWidth: '275px',
            fontStyle: 'italic',
            color: 'blue',
          }}
        >
          {mediaGuidelinesString}
        </Typography>
      }


      {/* Number of files selected text */}


      {/* Display the files selected (Images and video thumbnails) */}
      {
        (
          mediaArray.length > 0 
          ||
          ('media' in user && user.media !== null && user.media.length > 0)
        )
        &&
        displayNewMediaJSX(
          mediaArray, 
          loadingMedia, 
          handleDeleteImage,
          'media' in user && user.media !== null && user.media.length > 0 ? user.media : []
        )
      }

    </>
  )
}